"use client";

import { createGlobalStyle, ThemeProvider } from "styled-components";
import { AppearanceContext } from "./AppearanceContext.js";
import { getAllModeStyles } from "./modes";

/*
 * The root <Appearance> will include global styles. It is not meant for use beyond wrapping the application.
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const GlobalStyles = createGlobalStyle([":root,::backdrop{", "}", " ", " @media print{:root,::backdrop{", "}}"], getAllModeStyles("light"), ({
  mode
}) => mode === "dark" ? `:root, ::backdrop { ${getAllModeStyles("dark")} }` : ``, ({
  mode
}) => mode === "os" ? `@media (prefers-color-scheme: dark) {
        :root, ::backdrop { ${getAllModeStyles("dark")} }
      }` : ``, getAllModeStyles("light"));

/**
 * Provides "Appearance" related functionality for Eden. Adds official support for dark mode via the `mode` option. This would provide future centralized support for things that would have options to change the appearance of child Eden components.
 * @param {object} props - The component props
 * @param {"light" | "dark" | "os"} [props.mode] - What mode should be used
 * @param {React.ReactNode} props.children - The content to be rendered within the appearance component.
 * @returns {React.ReactElement} The rendered appearance component.
 */
const Appearance = ({
  children,
  mode = "os"
}) => {
  return /*#__PURE__*/_jsx(AppearanceContext.Provider, {
    value: {
      mode
    },
    children: /*#__PURE__*/_jsx(ThemeProvider, {
      theme: {
        edenAppearanceMode: mode
      },
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(GlobalStyles, {
          mode: mode
        }), children]
      })
    })
  });
};
Appearance.displayName = "Appearance";
export default Appearance;